export const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';
export const POST_LOGIN_REDIRECT_BACKUP_KEY = 'post_login_redirect_backup';
export const LOGIN_IN_PROGRESS_KEY = 'login_in_progress';

/** Normaliza rutas HashRouter: /#/shared/x → /shared/x */
export const normalizePostLoginPath = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  try {
    if (trimmed.includes('://')) {
      const url = new URL(trimmed);
      if (url.hash?.startsWith('#/')) return url.hash.slice(1);
      return url.pathname && url.pathname !== '/' ? url.pathname : null;
    }
  } catch (_) {
    // seguir con formatos relativos
  }

  if (trimmed.startsWith('/#/')) return trimmed.slice(2);
  if (trimmed.startsWith('#/')) return trimmed.slice(1);
  if (trimmed.startsWith('/')) return trimmed;
  return `/${trimmed}`;
};

const readStoredRedirectRaw = () => {
  try {
    return sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
      || localStorage.getItem(POST_LOGIN_REDIRECT_BACKUP_KEY);
  } catch (_) {
    return null;
  }
};

export const savePostLoginRedirect = (pathOrUrl) => {
  const path = normalizePostLoginPath(pathOrUrl);
  if (!path) return;
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
    localStorage.setItem(POST_LOGIN_REDIRECT_BACKUP_KEY, path);
  } catch (_) {
    // storage no disponible
  }
};

export const peekPostLoginRedirect = () => normalizePostLoginPath(readStoredRedirectRaw());

export const clearPostLoginRedirect = () => {
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    localStorage.removeItem(POST_LOGIN_REDIRECT_BACKUP_KEY);
  } catch (_) {
    // storage no disponible
  }
};

export const consumePostLoginRedirect = () => {
  const path = peekPostLoginRedirect();
  if (path) clearPostLoginRedirect();
  return path;
};

export const markLoginInProgress = (active = true) => {
  try {
    if (active) sessionStorage.setItem(LOGIN_IN_PROGRESS_KEY, '1');
    else sessionStorage.removeItem(LOGIN_IN_PROGRESS_KEY);
  } catch (_) {
    // storage no disponible
  }
};

export const isLoginInProgress = () => {
  try {
    return sessionStorage.getItem(LOGIN_IN_PROGRESS_KEY) === '1';
  } catch (_) {
    return false;
  }
};

/** URL completa para HashRouter (recarga segura tras login). */
export const buildPostLoginHashUrl = (path) => {
  const normalized = normalizePostLoginPath(path);
  if (!normalized) return null;
  const base = `${window.location.origin}${window.location.pathname}`;
  return `${base}#${normalized}`;
};

/**
 * Navega al destino pendiente con recarga completa (evita carreras con React Router
 * y PublicRoute, que de otro modo mandan a /app al actualizarse isLoggedIn).
 * @param {string} [capturedPath] Ruta capturada ANTES de actualizar isLoggedIn.
 */
export const applyPostLoginRedirect = (capturedPath) => {
  const path = normalizePostLoginPath(capturedPath) || consumePostLoginRedirect();
  if (!path) return false;
  clearPostLoginRedirect();
  markLoginInProgress(false);
  // HashRouter: fijar el hash destino y recargar para montar la app limpia en esa ruta.
  window.location.hash = path;
  window.location.reload();
  return true;
};
